import styled from 'styled-components';
import { Link } from 'react-router-dom';

/* Fondo oscuro semi-transparente para elementos internos (email, redes) */
const darkOverlay = bg => bg + '22'; // muy sutil — igual que la referencia usa #2a2a27

export const FooterWrapper = styled.footer`
  background: ${p => p.bg || '#0d0d14'};
  color: ${p => p.color || '#fff'};
  border-top: 3px solid ${p => p.accent || '#667eea'};
  padding: 48px 40px 0;
  margin-top: auto;

  @media (max-width: 700px) {
    padding: 36px 20px 0;
  }
`;

export const FooterGrid = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.8fr 1fr 1fr 1fr;
  gap: 40px;
  padding-bottom: 32px;
  border-bottom: 1px solid ${p => p.accent || '#667eea'}22;

  @media (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`;

export const Brand = styled.div``;

export const BrandName = styled.div`
  font-size: 20px;
  font-weight: 800;
  margin-bottom: 10px;
  color: ${p => p.color || '#fff'};
  span { color: ${p => p.accent || '#667eea'}; }
`;

export const BrandDesc = styled.p`
  font-size: 13px;
  color: ${p => p.color || '#fff'}88;
  line-height: 1.6;
  margin-bottom: 16px;
  max-width: 240px;
`;

/* Email como pastilla con fondo oscuro — igual que la referencia */
export const BrandEmail = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255,255,255,0.06);
  border: 1px solid rgba(255,255,255,0.18);
  border-radius: 8px;
  padding: 7px 14px;
  font-size: 13px;
  color: rgba(255,255,255,0.8);
  text-decoration: none;
  margin-bottom: 16px;
  transition: border-color 0.2s, color 0.2s;

  svg {
    width: 14px;
    height: 14px;
    color: ${p => p.accent || '#667eea'};
    flex-shrink: 0;
  }

  &:hover {
    border-color: ${p => p.accent || '#667eea'};
    color: #fff;
  }
`;

export const SocialRow = styled.div`
  display: flex;
  gap: 8px;
`;

/* Botones redes: fondo oscuro + hover relleno accent */
export const SocialBtn = styled.a`
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(255,255,255,0.18);
  color: rgba(255,255,255,0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: background 0.2s, color 0.2s, border-color 0.2s;

  &:hover {
    background: ${p => p.accent || '#667eea'};
    color: #fff;
    border-color: ${p => p.accent || '#667eea'};
  }
`;

export const FooterCol = styled.div``;

export const ColTitle = styled.h4`
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: ${p => p.color || '#fff'}66;
  margin-bottom: 14px;
`;

/* Lista y items sin bullet */
export const LinkList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const LinkItem = styled.li``;

/* Estilos compartidos para links con icono SVG */
const linkBase = `
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  text-decoration: none;
  transition: color 0.2s;

  svg {
    width: 14px;
    height: 14px;
    opacity: 0.5;
    flex-shrink: 0;
  }
`;

export const FooterLink = styled(Link)`
  ${linkBase}
  color: ${p => p.color || '#fff'}cc;
  &:hover { color: ${p => p.accent || '#667eea'}; svg { opacity: 1; } }
`;

export const FooterAnchor = styled.a`
  ${linkBase}
  color: ${p => p.small ? (p.color || '#fff') + '44' : (p.color || '#fff') + 'cc'};
  font-size: ${p => p.small ? '12px' : '13px'};
  &:hover { color: ${p => p.small ? (p.color || '#fff') + 'aa' : (p.accent || '#667eea')}; svg { opacity: 1; } }
`;

/* Barra inferior: copyright izq + links der */
export const FooterBottom = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0 20px;
  gap: 12px;
  flex-wrap: wrap;

  p {
    font-size: 12px;
    color: ${p => p.color || '#fff'}33;
  }
`;

export const LegalRow = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
`;
